var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"about"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v("This page is under construction.")]),_c('router-link',{attrs:{"to":"/"}},[_c('i',{staticClass:"fas fa-long-arrow-alt-left me-3"}),_vm._v("Home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }